//@ts-check

import React, { useState, useEffect, useRef } from "react"

/**
 * Like normal textarea but calling the onChange only onBlur. To make it much faster

 * @param props {React.DetailedHTMLProps<
        React.InputHTMLAttributes<HTMLInputElement>,
        HTMLInputElement
      >}
 */
function FastTextarea(props) {
  var a = useRef(null)
  function onBlur(e) {
    props.onChange(e)
  }
  useEffect(() => {
    a.current.value = props.value
  }, [props.value])
  return (
    //@ts-ignore
    <textarea
      ref={a}
      {...props}
      value={undefined}
      onChange={undefined}
      onBlur={onBlur}
    />
  )
}

export default FastTextarea
